import {
  createContext,
  useContext,
  useState,
  ReactNode,
  useCallback,
} from 'react'

export type LogEntry = {
  id: number
  from: string
  role?: string
  text: string
  outgoing: boolean
  avatarUrl: string
}

type ChatContextType = {
  logs: LogEntry[]
  addLog: (entry: Omit<LogEntry, 'id'>) => void
  clearLogs: () => void
}

const ChatContext = createContext<ChatContextType | undefined>(undefined)

let logId = 1

export const ChatProvider = ({ children }: { children: ReactNode }) => {
  const [logs, setLogs] = useState<LogEntry[]>([])

  const addLog = useCallback((entry: Omit<LogEntry, 'id'>) => {
    setLogs(prev => [...prev, { ...entry, id: logId++ }])
  }, [])

  const clearLogs = useCallback(() => {
    setLogs([])
    logId = 1
  }, [])

  return (
    <ChatContext.Provider value={{ logs, addLog, clearLogs }}>
      {children}
    </ChatContext.Provider>
  )
}

export const useChat = (): ChatContextType => {
  const context = useContext(ChatContext)
  if (!context) {
    throw new Error('useChat must be used inside ChatProvider')
  }
  return context
}
